type Props = {
  title: string;
  subtitle: string;
  description: string;
};

export function SectionHeader({ title, subtitle, description }: Props) {
  const hasHeading = Boolean(title || subtitle);

  if (!hasHeading && !description) {
    return null;
  }

  return (
    <div className="flex w-full flex-col gap-4 md:gap-5">
      {hasHeading && (
        <h2 className="w-full break-words text-[28px] font-medium leading-[1.2] md:text-[42px]">
          {title ? (
            <span className="block w-full text-[#05f273]">{title}</span>
          ) : null}
          {subtitle ? (
            <span className="block w-full text-white">{subtitle}</span>
          ) : null}
        </h2>
      )}
      {description ? (
        <p className="w-full text-[16px] font-light leading-[1.5] text-white md:text-[18px]">
          {description}
        </p>
      ) : null}
    </div>
  );
}
